import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoArrowBackSharp, IoArrowForwardSharp } from "react-icons/io5";
import { MdDoneAll } from "react-icons/md";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Row,
} from "reactstrap";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  convertToDateString,
  getStringFromJSX,
  isUrdu,
  LoadingSpinner,
} from "../../../../constants/const";
import { GetLanguageString } from "../../../helper/Components";
import { GetSelectedLanguage } from "../../../helper/Method";
import { addMember } from "../../ApiMember";
import ResponsibilityErrorMessage from "../ResponsibilityErrorMessage";
import FormStepDeen from "./FormStepDeen";
import FormStepTanzeem from "./FormStepTanzeem";
import FormStepTasurat from "./FormStepTasurat";

const colors = {
  primary: "#1d9fad", // New primary color (teal-cyan)
  primaryLight: "#4dbbc8", // Lighter variant of new primary
  primaryDark: "#147d89", // Darker variant of new primary
  secondary: "#7DB9A2", // Dusty seafoam green
  accent: "#94C4CC", // Pale sky blue
  background: "#F8FBFB", // Very light blue-white
  text: "#2D3747", // Dark blue-gray
  textLight: "#6B7C8C", // Soft blue-gray
  border: "#D8E1E6", // Light blue-gray
  success: "#5AB885", // Muted green
  warning: "#E4B363", // Soft gold
  error: "#E67C73", // Dusty coral
  progressLine: "#D1DDE5", // Very light blue-gray
  stepInactive: "#E0E8EC", // Pale blue for inactive steps
};

const NaqeebResponsibilityRequestForm = ({ responsibilityValues, history }) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(1);
  const [buttonDisable, setButtonDisable] = useState(false);
  const selectedLanguage = GetSelectedLanguage();
  const [displayMessageModal, setDisplayMessageModal] = useState(false);
  const notify = (string) => toast.success(string);
  const [errorMessages, setErrorMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hoverStep, setHoverStep] = useState(null);
  const [values, setValues] = useState({
    memberRegNo: "",
    memberName: "",
    previousNaqeeb: "",
    isOneYearMultazim: false,
    isMultzimCourseCompleted: false,
    isNuqabaCourseCompleted: false,
    isMultazimNisaabCompleted: false,
    isRegularInIjtimaat: false,
    isInformingNotAttendingIjtimaInCaseOfEmergency: false,
    isGivingFundRegularly: false,
    isRespectfulInGivingSuggestion: false,
    isPrayingObligatoryPrayersInMasjid: false,
    taluqMaAllah: "",
    isMaintainingPhysicallyAccordingToSunnah: false,
    isMaintainingPardah: false,
    sourceOfIncome: "",
    financialStatus: "",
    isReadNizamUlAmalAndRahnumaAsool: false,
    otherInformation: "",
    dateOfRequest: responsibilityValues.responsibilityDate,
    muqamiAmeerName: "",
    muqamiAmeerFeedback: "",
    muqamiTanzeemName: "",
    ameerHalqaName: "",
    ameerHalqaFeedback: "",
  });

  useEffect(() => {
    setLoading(true);
    addMember()
      .MemberResponsibilityRequestNaqeebFormData(
        responsibilityValues.memberId,
        responsibilityValues.memberRegNo,
        responsibilityValues.responsibility.value,
        responsibilityValues.unit.value
      )
      .then((res) => {
        setValues({
          ...values,
          memberName: res.data.memberName,
          memberRegNo: res.data.memberRegNo,
          previousNaqeeb: res.data.previousNaqeeb,
          isOneYearMultazim: res.data.isOneYearMultazim,
          isMultzimCourseCompleted: res.data.isMultzimCourseCompleted,
          isMultazimNisaabCompleted: res.data.isMultazimNisaabCompleted,
          isNuqabaCourseCompleted: res.data.isNuqabaCourseCompleted,
          muqamiAmeerName: res.data.muqamiAmeerName,
          muqamiTanzeemName: res.data.muqamiTanzeemName,
          ameerHalqaName: res.data.ameerHalqaName,
          sourceOfIncome: res.data.sourceOfIncome,
        });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [responsibilityValues]);

  const nextStep = () => {
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleCheckBoxes = (e) => {
    const { name, value } = e.target;
    let val = value === "true";
    setValues({
      ...values,
      [name]: val,
    });
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <FormStepDeen
            setValues={setValues}
            values={values}
            handleCheckBoxes={handleCheckBoxes}
          />
        );
      case 2:
        return (
          <FormStepTanzeem
            values={values}
            setValues={setValues}
            handleCheckBoxes={handleCheckBoxes}
            handleInputChange={handleInputChange}
          />
        );
      case 3:
        return <FormStepTasurat values={values} setValues={setValues} />;
      default:
        return null;
    }
  };
  const handleSubmit = () => {
    values.proposedResponsibility = responsibilityValues.responsibility;
    values.dateOfRequest = convertToDateString(new Date());

    responsibilityValues.naqeebRequest = values;

    setButtonDisable(true);
    setLoading(true);
    addMember()
      .addMemberResponsibility(responsibilityValues, false)
      .then((res) => {
        if (res.data.requestExists) {
          swal({
            title: t("member__request_exists_for_assign_responsibility"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "error",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          });
          history.goBack();
          setLoading(false);
          setButtonDisable(false);
        } else if (res.data === "Invalid Data") {
          notify(res.data);
          setLoading(false);
          setButtonDisable(false);
        } else if (res.data.cannotAssignResponsibility) {
          swal({
            title: t(
              "member__member_responsibility_error_cannot_assign_resposnibility"
            ),
            icon: "error",
            buttons: "OK",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
          });
          setButtonDisable(false);
          setLoading(false);
        } else if (
          !res.data.thisMemberHaveResponsibility &&
          !res.data.otherMemberHaveResponsibility &&
          !res.data.isUsraMavin
        ) {
          swal({
            title: t("member__request_success_for_assign_responsibility"),
            icon: "success",
            buttons: "OK",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
          });
          history.goBack();
          setLoading(false);
          setButtonDisable(false);
        } else {
          setErrorMessages(res.data);
          setDisplayMessageModal(true);
          setLoading(false);
          setButtonDisable(false);
        }
      })
      .catch((err) => {
        swal({
          title: err,
          icon: "error",
          buttons: "OK",
        });
        console.log(err);
        setLoading(false);
        setButtonDisable(false);
      });
    console.log(responsibilityValues);
  };

  const getStepTitle = (step) => {
    switch (step) {
      case 1:
        return "دینی اعتبار سے";
      case 2:
        return "تنظیمی اعتبار سے";
      case 3:
        return "امیر کے تاثرات";
      default:
        return "";
    }
  };

  return (
    <div
      className="ibox-content"
      style={{
        backgroundColor: colors.background,
        borderRadius: "12px",
        padding: "24px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
      }}
    >
      {!loading ? (
        <>
          {displayMessageModal ? (
            <ResponsibilityErrorMessage
              setDisplayMessageModal={setDisplayMessageModal}
              data={errorMessages}
              displayName={responsibilityValues.displayName}
            />
          ) : null}

          <div
            style={{
              backgroundColor: colors.background,
              borderRadius: "12px",
              padding: "12px",
              marginBottom: "24px",
            }}
          >
            <Row>
              <Col md="4">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",

                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString props={"common_name"} />
                    </CardTitle>
                    <CardText
                      className={isUrdu(values.memberName) ? "ur" : ""}
                      style={{
                        fontSize: "16px",
                        color: colors.text,
                        wordBreak: "break-word",
                      }}
                    >
                      {values.memberName || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString props={"member_reg_number"} />
                    </CardTitle>
                    <CardText
                      className={isUrdu(values.memberRegNo) ? "ur" : ""}
                      style={{
                        fontSize: "16px",
                        color: colors.text,
                        wordBreak: "break-word",
                      }}
                    >
                      {getStringFromJSX(
                        applyClassToCharacters(values.memberRegNo, "ur")
                      ) || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString
                        props={
                          "member__request_previous_naqeeb_assign_responsibility"
                        }
                      />
                    </CardTitle>
                    <CardText
                      className="ur"
                      style={{
                        fontSize: "16px",
                        color: colors.text,
                        wordBreak: "break-word",
                      }}
                    >
                      {values.previousNaqeeb || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          <div className="position-relative mb-5" style={{ padding: "0 10%" }}>
            {/* Progress Line - now full width */}
            <div
              className="position-absolute"
              style={{
                height: "3px",
                backgroundColor: colors.progressLine,
                top: "32%",
                left: "0",
                right: "0",
                transform: "translateY(-50%)",
                zIndex: 1,
                borderRadius: "3px",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${
                    currentStep === 1 ? 23 : currentStep === 2 ? 50 : 78
                  }%`,
                  backgroundColor: colors.primary,
                  transition: "width 0.5s ease",
                  borderRadius: "3px",
                }}
              />
            </div>{" "}
            <Row className="position-relative" style={{ zIndex: 2 }}>
              {[1, 2, 3].map((step) => (
                <Col key={step} className="text-center">
                  <div className="d-flex flex-column align-items-center">
                    <Button
                      onClick={() =>
                        currentStep >= step && setCurrentStep(step)
                      }
                      onMouseEnter={() => setHoverStep(step)}
                      onMouseLeave={() => setHoverStep(null)}
                      disabled={currentStep < step}
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "8px",
                        fontSize: "18px",
                        fontWeight: "bold",
                        boxShadow:
                          currentStep >= step
                            ? `0 2px 8px ${colors.primary}40`
                            : "none",
                        background:
                          currentStep >= step
                            ? hoverStep === step
                              ? colors.primaryDark
                              : colors.primary
                            : "white",
                        border:
                          currentStep >= step
                            ? "none"
                            : `3px solid ${colors.progressLine}`,
                        color: currentStep >= step ? "white" : colors.textLight,
                        cursor: currentStep >= step ? "pointer" : "not-allowed",
                        transition: "all 0.3s ease",
                        position: "relative",
                        borderColor:
                          currentStep === step
                            ? colors.primary
                            : colors.progressLine,
                      }}
                    >
                      {step}
                      {/* Small indicator for current step */}
                      {currentStep === step && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: "-10px",
                            width: "0",
                            height: "0",
                            borderLeft: "8px solid transparent",
                            borderRight: "8px solid transparent",
                            borderTop: `8px solid ${colors.primary}`,
                          }}
                        />
                      )}
                    </Button>
                    <div
                      className="text-center ur"
                      style={{
                        fontWeight: currentStep >= step ? "600" : "500",
                        color:
                          currentStep >= step
                            ? colors.primary
                            : colors.textLight,
                        fontSize: "20px",
                        transition: "color 0.3s ease",
                      }}
                    >
                      <span style={{ marginTop: 50 }}>
                        {getStepTitle(step)}
                      </span>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          <div
            className="ibox-content p-4 mb-4"
            style={{
              minHeight: "200px",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.05)",
              border: `1px solid ${colors.border}`,
              backgroundColor: "white",
            }}
          >
            {renderStepContent()}
          </div>

          <div className="d-flex justify-content-between">
            <Button
              color="default"
              onClick={prevStep}
              disabled={currentStep === 1}
              className="px-4"
              style={{
                background: currentStep === 1 ? colors.background : "white",
                color: currentStep === 1 ? colors.textLight : colors.primary,
                border:
                  currentStep === 1
                    ? `1px solid ${colors.border}`
                    : `1px solid ${colors.primary}`,
                borderRadius: "8px",
                transition: "all 0.3s ease",
                fontWeight: "500",
                padding: "10px 24px",
                display: "flex",
                alignItems: "center",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              }}
            >
              {selectedLanguage === "ur" ? (
                <IoArrowForwardSharp
                  color={currentStep === 1 ? colors.textLight : colors.primary}
                  size={15}
                  style={{ marginLeft: 5, marginBottom: 1 }}
                />
              ) : (
                <IoArrowBackSharp
                  color={currentStep === 1 ? colors.textLight : colors.primary}
                  size={15}
                  style={{ marginRight: 5, marginBottom: 1 }}
                />
              )}
              <GetLanguageString props={"Previous"} />
            </Button>

            {currentStep === 3 ? (
              <Button
                color={"default"}
                onClick={handleSubmit}
                disabled={buttonDisable}
                className="px-4"
                style={{
                  background: buttonDisable
                    ? colors.border
                    : `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
                  color: "white",
                  borderRadius: "8px",
                  border: "none",
                  transition: "all 0.3s ease",
                  fontWeight: "500",
                  padding: "10px 24px",
                  boxShadow: buttonDisable
                    ? "none"
                    : `0 4px 15px ${colors.primary}30`,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <MdDoneAll
                  color="white"
                  size={17}
                  style={{ marginRight: 5, marginBottom: 1 }}
                />
                <GetLanguageString props={"Submit"} />
              </Button>
            ) : (
              <Button
                color={"default"}
                onClick={nextStep}
                disabled={currentStep === 3}
                className="px-4"
                style={{
                  background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
                  color: "white",
                  borderRadius: "8px",
                  border: "none",
                  transition: "all 0.3s ease",
                  fontWeight: "500",
                  padding: "10px 24px",
                  boxShadow: `0 4px 15px ${colors.primary}30`,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <GetLanguageString props={"Next"} />
                {selectedLanguage === "ur" ? (
                  <IoArrowBackSharp
                    color="white"
                    size={15}
                    style={{ marginRight: 5, marginBottom: 1 }}
                  />
                ) : (
                  <IoArrowForwardSharp
                    color="white"
                    size={15}
                    style={{ marginLeft: 5, marginBottom: 1 }}
                  />
                )}
              </Button>
            )}
          </div>
        </>
      ) : (
        LoadingSpinner()
      )}
    </div>
  );
};

export default withRouter(NaqeebResponsibilityRequestForm);
